import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface NavSearchProps {
  onOpen: () => void;
}

const isMac = () =>
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad|iPod/.test(navigator.platform);

const NavSearch = ({ onOpen }: NavSearchProps) => {
  const shortcutKey = isMac() ? "\u2318K" : "Ctrl K";

  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Open global search"
      className="group flex items-center gap-2 w-full max-w-sm h-8 px-3 text-sm text-gray-500 bg-gray-100 hover:bg-white border border-transparent hover:border-gray-200 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:bg-white"
    >
      <MagnifyingGlassIcon
        className="h-4 w-4 text-gray-400 group-hover:text-gray-500 flex-shrink-0"
        aria-hidden="true"
      />
      <span className="flex-1 text-left truncate">
        Search users&hellip;
      </span>
      <kbd className="hidden sm:inline-flex items-center px-1.5 h-5 text-[10px] font-medium text-gray-500 bg-white border border-gray-200 rounded shadow-sm">
        {shortcutKey}
      </kbd>
    </button>
  );
};

export default NavSearch;
